import { Box, Typography, Link } from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import DividerImage from '../components/Divider';
import HeaderImage from "../components/HeaderImage";
import Map from "../components/Map";

function Contact() {
    return (
        <Box>
            <HeaderImage />
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <Box sx={{ padding: 2, textAlign: "center" }}>
                    <Typography variant="h4">Umów się na wizytę w salonie</Typography>

                    <DividerImage />

                    <Box sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        mt: 1
                    }}>
                        <PhoneIcon sx={{ mr: 1 }} />
                        <Link
                            href="tel:+48512208653"
                            underline="hover"
                            color="inherit"
                            sx={{ cursor: "pointer" }}
                        >
                            +48 512 208 653
                        </Link>
                    </Box>

                    <Box sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        mt: 1
                    }}>
                        <LocationOnIcon sx={{ mr: 1 }} />
                        <Link
                            href="https://maps.app.goo.gl/581baiv3t3V5WLz89"
                            target="_blank"
                            rel="noopener noreferrer"
                            underline="hover"
                            color="inherit"
                            sx={{ cursor: "pointer" }}
                        >
                            ul. Łagiewnicka 85, Łódź
                        </Link>
                    </Box>
                </Box>

                <Map />

            </Box>
        </Box>
    );
};

export default Contact;
